module.exports = __webpack_public_path__ + "img/Aura_blood.b71eacd5.png";